import { useQuery } from '@tanstack/react-query';
import { getEmailNotificationSettings } from '../service';

function useEmailNotificationSettings(email: string | null) {
    return useQuery({
        queryKey: ['me', 'email-notification-settings', email],
        queryFn: () => getEmailNotificationSettings(email!),
        enabled: email !== null && email.length > 0,
    });
}

export { useEmailNotificationSettings };
